import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/arrow/client_back.webp";

function Clientarrow() {
  return (
    <section
      className="client_arrow text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Client's Brief</h2>
            <p>
              The brief here was simple, the client wanted a platform which
              served as an integrated marketplace for the purpose of buying and
              selling of catalytic converters.
            </p>
            <p>
              Unlike other platforms we’ve developed thus far, this time around
              the client had a very clear set of goals that it needed the
              platform to attain.
            </p>
            <p>
              In the initial brief, the client shared that this platform should
              be a place where anyone could know the current market price of
              catalytic converters, search for them via things like serial
              numbers, make or build, each inventory item needs to be
              accompanied by photos that can be swiped left or right for easier
              viewing and a calculator that provides estimated cost of a
              catalytic converter based on existing market rates.
            </p>
            <p>
              The brief allowed us to have a basic but firm understanding of
              what was needed in the platform, allowing us to modify and create
              features suited to fit the needs of the client.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/arrow/client_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={327}
                height={651}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientarrow;
